import { CompanyColorSchemaEnum } from "../../../../../../../lib/branding/branding.model";

export const ID_VERSE_LOGO_IDEA = 'assets/id-verse/id-verse-idea.png';
export const ID_VERSE_LOGO_LEVELESQ = 'assets/id-verse/id-verse-levelesq.png';
export const QR_LOGO_IDEA = 'assets/logos/idea_rhino.png';
export const QR_LOGO_LEVELESQ = 'assets/logos/level.png';
export const MOBILE_DOWNLOAD_PATH = '/mobile/download';
export const SKIP_PROMO_SESSION_KEY = 'idverse-skip-promo';

export const ID_VERSE_DESKTOP_POLLING_INTERVAL_MS = 10 * 1000;
export const ID_VERSE_DESKTOP_POLLING_TIMEOUT_MS = 15 * 60 * 1000;
export const ID_VERSE_MOBILE_POLLING_INTERVAL_MS = 3000;
export const ID_VERSE_MOBILE_POLLING_TIMEOUT_MS = 2 * 60 * 1000;
export const ID_VERSE_MOBILE_SYNCING_TIMER_INTERVAL_MS = 1000;
export const ID_VERSE_MOBILE_SYNCING_DELAY_THRESHOLD_MS = 30 * 1000;

export const getIdVerseLogoUrl = (colorSchema: CompanyColorSchemaEnum): string =>
  colorSchema === CompanyColorSchemaEnum.LevelEsq
    ? ID_VERSE_LOGO_LEVELESQ
    : ID_VERSE_LOGO_IDEA;

export const getQrLogoUrl = (colorSchema: CompanyColorSchemaEnum): string =>
  colorSchema === CompanyColorSchemaEnum.LevelEsq
    ? QR_LOGO_LEVELESQ
    : QR_LOGO_IDEA;

export const getMobileDownloadUrl = (portalUrl: string): string | null =>
  portalUrl ? `${portalUrl}${MOBILE_DOWNLOAD_PATH}` : null;
